var _path, _path2, _g, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRowan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z",
    fill: "url(#paint0_linear_3426_33851)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "url(#paint1_linear_3426_33851)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3426_33851)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4558 3.8511C15.8822 3.6895 15.3802 3.87679 15.0162 4.26464C14.679 4.62388 14.4631 5.1451 14.3315 5.7027C14.1663 6.4027 14.1138 7.24624 14.1762 8.11361C13.8162 8.33504 13.1338 8.77674 12.3205 9.42273C11.4646 8.93047 10.2551 8.91092 9.10484 9.53114C8.38427 9.91967 7.77887 10.6597 7.35042 11.4967C6.91785 12.3418 6.63668 13.3408 6.60584 14.3102C6.58134 15.0805 6.7149 15.8616 7.08574 16.5292C6.6259 18.129 6.82349 19.3759 7.3619 20.3006C7.97142 21.3474 8.97051 21.8985 9.7157 22.0909C9.98308 22.1599 10.2558 21.9991 10.3248 21.7317C10.3938 21.4643 10.233 21.1916 9.96563 21.1226C9.42323 20.9826 8.6747 20.5679 8.22608 19.7974C7.91407 19.2616 7.72204 18.5098 7.89253 17.4796C8.51121 17.9655 9.3489 18.2458 10.4104 18.2594C11.6981 18.2759 12.7227 17.941 13.5136 17.3543C13.5245 17.3487 13.5352 17.3427 13.5458 17.3362C14.9866 16.4588 15.6527 14.9936 15.8589 13.5364C16.0609 12.1077 15.8325 10.6276 15.412 9.55614C15.4051 9.52553 15.3981 9.49529 15.3909 9.46542C15.3211 9.17218 15.267 8.87389 15.2279 8.57678L15.2675 8.53636C15.38 8.42038 15.5215 8.26596 15.6766 8.08564C15.9858 7.7263 16.3607 7.2509 16.6746 6.7577C16.9786 6.28005 17.2655 5.72466 17.3324 5.21848C17.3669 4.9572 17.3493 4.66071 17.195 4.39253C17.0347 4.11396 16.7697 3.93953 16.4558 3.8511ZM14.4314 9.75363C14.427 9.73461 14.4226 9.71575 14.4181 9.69704C14.3799 9.53655 14.3458 9.37432 14.3158 9.21115C13.9879 9.42683 13.5568 9.72641 13.071 10.1053C13.1053 10.1546 13.1377 10.2054 13.1681 10.2578C13.5204 10.864 13.5594 11.6151 13.2128 12.3656C12.8718 13.1038 12.1703 13.8224 11.0713 14.4545C10.8319 14.5922 10.5262 14.5098 10.3886 14.2704C10.2509 14.031 10.3333 13.7254 10.5727 13.5877C11.5588 13.0205 12.0782 12.4372 12.3049 11.9463C12.5259 11.4677 12.4792 11.0625 12.3035 10.7602L12.2941 10.7443C10.852 11.9943 9.18678 13.817 8.28106 16.1198C8.24699 16.2065 8.21508 16.2917 8.18526 16.3754L8.18804 16.3788C8.59778 16.8746 9.28732 17.2449 10.4232 17.2595C11.5734 17.2742 12.4015 16.9637 13.0037 16.4852C13.6118 16.0019 14.0289 15.3156 14.2947 14.5176C14.8108 12.9687 14.7235 11.0965 14.4517 9.84449C14.442 9.81443 14.4352 9.78403 14.4314 9.75363ZM15.8309 6.22079C15.6242 6.54569 15.3833 6.8683 15.155 7.15022C15.1693 6.70607 15.22 6.29149 15.3048 5.93241C15.4181 5.45226 15.5795 5.1256 15.7453 4.94904C15.8842 4.80109 16.0108 4.76466 16.1847 4.81364C16.3041 4.84727 16.3254 4.88604 16.328 4.8909L16.3282 4.89123C16.336 4.90467 16.3583 4.957 16.341 5.08751C16.3044 5.36491 16.121 5.76497 15.8309 6.22079ZM11.4654 10.141C10.1187 11.3372 8.61574 13 7.64437 15.0717C7.61007 14.84 7.59726 14.5956 7.60533 14.342C7.63103 13.534 7.86871 12.6788 8.24057 11.9524C8.61655 11.2179 9.10116 10.6692 9.57944 10.4113C10.303 10.0212 10.9632 9.98676 11.4654 10.141Z",
    fill: "#F8DF91"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9739 1.81494C3.63926 1.81494 2.19189 9.12524 2.19189 9.12524C2.19189 9.12524 4.61043 2.91417 11.9739 2.82148C19.3374 2.72879 21.8713 9.12525 21.8713 9.12525C21.8713 9.12525 20.3086 1.81494 11.9739 1.81494Z",
    fill: "#F8CE4C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3426_33851",
    x: 6.60303,
    y: 3.79297,
    width: 11.0441,
    height: 18.314,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3426_33851"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3426_33851",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3426_33851",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAAB17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A98B30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3426_33851",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8DA7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#524210"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRowan);
export default __webpack_public_path__ + "static/media/rowan.44dd10869c7f63de41abce8b52b1b08d.svg";
export { ForwardRef as ReactComponent };